import React, { FC } from 'react';
import { ParagraphSingleSegment } from '../../store/guide';

interface SingleSegmentParagraphProps {
  segment: ParagraphSingleSegment;
  onLinkClick: (targetId: string) => void;
}

const SingleSegmentParagraph: FC<SingleSegmentParagraphProps> = ({
  segment,
  onLinkClick,
}) => {
  if (segment.type === 'link') {
    return (
      <div className="mt-2">
        <button
          type="button"
          onClick={() => {
            onLinkClick(segment.linkTo);
          }}
          className="text-sm leading-6 text-workorder-500 underline"
        >
          {segment.text}
        </button>
      </div>
    );
  }
  if (segment.type === 'li') {
    return (
      <li className="ml-3 text-xs leading-4 tracking-[0.5px]">
        {segment.text}
      </li>
    );
  }
  return <p className="mt-2 text-sm leading-6">{segment.text}</p>;
};

export default SingleSegmentParagraph;
